module.exports = __webpack_public_path__ + "assets/img/binding-1.b61ab704.jpg";